"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Item = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _elements = require("../../styles/elements");

var Item = (0, _base["default"])("li", {
  target: "eu5flaj0",
  label: "Item"
})("button{border-color:", function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return active && theme.color.buttonPrimary.borderHover;
}, ";}");
exports.Item = Item;

var ButtonListItem = function ButtonListItem(_ref2) {
  var active = _ref2.active,
      icon = _ref2.icon,
      name = _ref2.name,
      onSelect = _ref2.onSelect,
      type = _ref2.type,
      size = _ref2.size,
      title = _ref2.title,
      btnType = _ref2.btnType,
      disabled = _ref2.disabled,
      tooltipTitle = _ref2.tooltipTitle;
  var onItemClick = (0, _react.useCallback)(function () {
    onSelect(type);
  }, [onSelect, type]);
  var button = (0, _jsxRuntime.jsxs)(_Button["default"], {
    disabled: disabled,
    customIcon: icon,
    type: btnType,
    onClick: onItemClick,
    "data-test-id": "button-list-item-".concat(type),
    children: [size === 'big' && name && (0, _jsxRuntime.jsx)("span", {
      css: [_elements.paragraph.styles.preflight, _elements.text.styles.textNormal, _elements.text.styles.fontSemibold, process.env.NODE_ENV === "production" ? "" : ";label:button;"],
      className: "grui mb-1 block",
      children: name
    }), title]
  });

  if (tooltipTitle) {
    return (0, _jsxRuntime.jsx)(Item, {
      active: active,
      children: (0, _jsxRuntime.jsx)(_Tooltip["default"], {
        title: tooltipTitle,
        position: "top",
        children: (0, _jsxRuntime.jsx)("div", {
          children: button
        })
      })
    }, type);
  }

  return (0, _jsxRuntime.jsx)(Item, {
    active: active,
    children: button
  }, type);
};

ButtonListItem.propTypes = {
  active: _propTypes.bool,
  icon: _propTypes.node,
  name: _propTypes.string,
  type: _propTypes.string,
  title: _propTypes.string,
  onSelect: _propTypes.func,
  size: (0, _propTypes.oneOf)(['big', 'small']),
  btnType: _propTypes.string,
  disabled: _propTypes.bool,
  tooltipTitle: _propTypes.string
};
ButtonListItem.defaultProps = {
  active: undefined,
  icon: undefined,
  name: undefined,
  type: undefined,
  title: undefined,
  onSelect: function onSelect() {},
  size: 'small',
  btnType: 'tertiary',
  disabled: false,
  tooltipTitle: undefined
};
var _default = ButtonListItem;
exports["default"] = _default;
//# sourceMappingURL=ButtonListItem.js.map